var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.568,
    height: 41.569,
    viewBox: "0 0 41.568 41.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(9.682 13.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M989.861,415.866a4.855,4.855,0,0,0-4.855-4.855H972.512a4.855,4.855,0,0,0-4.855,4.855v5.483a4.855,4.855,0,0,0,4.855,4.855h12.495a4.855,4.855,0,0,0,4.855-4.855Zm-6.871,2.886-5.587,2.754c-.219.118-.981-.04-.981-.288v-5.653c0-.252.769-.409.987-.285l5.339,2.9C982.971,418.306,983.216,418.629,982.99,418.752Z",
    transform: "translate(-967.657 -411.011)",
    fill: "#05B4EF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M970.986,387.235a20.784,20.784,0,1,0,20.784,20.784A20.808,20.808,0,0,0,970.986,387.235Zm0,38.9A18.118,18.118,0,1,1,989.1,408.019,18.139,18.139,0,0,1,970.986,426.138Z",
    transform: "translate(-950.202 -387.235)",
    fill: "#05B4EF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.09535d2ea15fcc8b4ff632a6dcfc7102.svg";
export { ForwardRef as ReactComponent };